import axios from "@axios";
import store from "@/store";

export default {
  state: {
    userViews: [],
    allViews: [],
    totalRecords: 0
  },
  getters: {
    getUserViews(state) {
      return state.userViews.map((userView) => ({
        id: userView.id,
        name: userView.name,
        data: userView.data,
        layout_id: userView.data.layout,
        updated_at: userView.updated_at,
        id_user: userView.id_user,
        coordinates: userView.coordinates,
        validations: userView.validations,
        last_status: userView.last_status
      }));
    },
    getUserViewsAll(state) {
      return state.allViews.map((userView) => ({
        id: userView.id,
        name: userView.name,
        data: userView.data,
        id_user: userView.id_user,
        layout_id: userView.data.layout,
        updated_at: userView.updated_at,
      }));
    },
    getTotalRecordsOfViews(state) {
      return state.totalRecords
    }
  },
  mutations: {
    setUserViewsAll(state, value) {
      state.allViews = value;
    },
    setUserViews(state, value) {
      state.userViews = value;
    },
    setTotalUserViewsRecords(state, value) {
      state.totalRecords = value;
    },
    updateView(state, value) {
      let view = state.userViews.find((view) => view.data.id === value.tabId);
      view.data = Object.assign(view.data, { ...value.data });
      view.name = view.data.name;
      view.updated_at = new Date().getTime();
    },
    updateViewVideoWall(state, value) {
      let view = state.allViews.find((view) => view.data.id === value.tabId);
      view.data = Object.assign(view.data, { ...value.data });
      view.name = view.data.name;
      view.updated_at = new Date().getTime();
    },
    removeView(state, value) {
      state.userViews = state.userViews.filter((view) => view.id !== value);
    },
  },
  actions: {
    async getUserViews({ commit }, pagination) {
      const params = {
        q: pagination?.search,
        max: pagination?.max ?? 4,
        "page[n]": pagination?.currentPage ?? 1
      }
      const { data } = await axios.get("v1/user-views", {params});
      commit("setUserViews", data.data);

      if (!data.success) {
        return [];
      }
      commit("setTotalUserViewsRecords", data.meta.total);
      return data;
    },
    createOrUpdateView({ commit, dispatch, getters, rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const view = getters["getUserViews"].find(
            (view) => view.data.id === payload.tabId
          );

          // Determinar si el layout ha sido modificado comparando los slots actuales con los originales
          let createNewLayout = false;
          let newLayoutId = null;

          if (view) {
            // Obtener el layout original
            const originalLayoutId = view.data.layout;
            const originalLayout = rootGetters["layouts/getUserLayouts"].find(
              (l) => l.id === originalLayoutId
            );

            // Obtener los slots actuales del grid
            const currentGridItems = rootGetters["grid/currentGridItems"];

            // Verificar si la estructura del layout ha cambiado
            if (originalLayout && currentGridItems.length > 0) {
              // Comparar estructura básica (cantidad de slots, posiciones)
              createNewLayout = hasLayoutChanged(originalLayout.grid, currentGridItems);
            }

            // Si el layout ha cambiado, crear uno nuevo
            if (createNewLayout) {
              // Obtener propiedades del layout original para duplicarlas
              const newLayoutData = {
                name: `${originalLayout.name} - Copy`,
                data: currentGridItems.map(item => ({
                  ...item,
                  pos: item.pos || (item.y * 12 + item.x) + 1,
                  x: item.x !== undefined ? item.x : 0,
                  y: item.y !== undefined ? item.y : 0,
                  w: item.w || 3,
                  h: item.h || 2,
                  minW: item.minW || 1,
                  minH: item.minH || 1,
                  data: null,
                  type: null,
                  name: null,
                  type2: null,
                })),
                id_tenant: originalLayout.id_tenant || null,
                users: originalLayout.users || [],
                is_default: originalLayout.is_default || 0,
                is_card: originalLayout.distance > 0 ? 1 : 0,
                distance: originalLayout.distance || 0
              };

              // Guardar el nuevo layout
              const layoutResult = await dispatch("layouts/saveLayout", newLayoutData, { root: true });
              newLayoutId = layoutResult.data.id;

              // Actualizar el layout_id en los datos de la vista
              payload.data.layout = newLayoutId;
            }

            // Actualizar la vista
            commit("updateView", payload);
            await axios.put(`v1/user-views/${view.id}`, payload);
          } else {
            // Es una vista nueva, guardar normalmente
            const { data } = await axios.post("v1/user-views", payload);
            dispatch("getUserViews");
          }

          resolve({ newLayoutCreated: createNewLayout, newLayoutId });
        } catch (error) {
          reject(error);
        }
      });
    },
    createView({ commit, dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await axios.post("v1/user-views", payload);
          commit("setUserViews", data.data);
          dispatch("getUserViews");
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    async updateView({ commit }, payload) {
      return axios
        .put(`v1/user-views/${payload.id}`, payload)
        .then(() => {
          commit("updateView", payload);
        })
        .catch((error) => {
          console.log("Update View: ", error.response);
        });
    },
    createOrUpdateViewvideoWall({ commit, dispatch, getters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("getUserViewsAll");
          console.log(getters["getUserViewsAll"]);
          let views = getters["getUserViewsAll"];
          let listViews = [];
          views.forEach((element) => {
            listViews.push({
              id: element.id,
              tabId: element.data.id,
            });
          });
          console.log("nuevo array", listViews);
          console.log("vista", payload);

          const exists = listViews.some((obj) => obj.tabId === payload.tabId);
          let updateViewVideoWall = true;
          if (exists == false) {
            updateViewVideoWall = false;
          }
          if (updateViewVideoWall) {
            axios.put(`v1/users/videowallusers/updateview/${payload.id}`, payload);
          } else {
            const { data } = axios.post(
              `v1/users/videowallusers/view/${payload.id}`,
              payload
            );
          }
          dispatch("getUserViewsAll");
          store.dispatch("video_wall/uservideowall");
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    async removeView({ commit }, payload) {
      return axios
        .delete(`v1/user-views/${payload.id}`)
        .then(() => {
          commit("removeView", payload.id);
        })
        .catch((error) => {
          console.log("Remove View: ", error.response);
        });
    },
    async removeViewVideoWall({ commit }, payload) {
      return axios
        .delete(`v1/users/videowallusers/deleteviewvideowall/${payload}`)
        .then(() => {
        })
        .catch((error) => {
          console.log("Remove View: ", error.response);
        });
    },
    async getUserViewsAll({ commit }) {
      const { data } = await axios.get("v1/users/videowallusers/viewall");
      commit("setUserViewsAll", data.data);

      if (!data.success) {
        return [];
      }
      console.log(data);
      return data;
    },
  },
};

// Compara layouts
function hasLayoutChanged(originalGrid, currentGrid) {
  // Comparación simplificada: verificar cantidad de items y posiciones
  if (originalGrid.length !== currentGrid.length) return true;

  // Verificar si algún elemento ha cambiado posición, tamaño o propiedades importantes
  for (let i = 0; i < originalGrid.length; i++) {
    const original = originalGrid[i];
    // Buscar el item correspondiente por ID
    const current = currentGrid.find(item => item.id === original.id);

    if (!current) return true; // Si no se encuentra, ha cambiado

    // Comparar propiedades principales
    if (current.x !== original.x ||
      current.y !== original.y ||
      current.pos !== original.pos ||
      current.w !== original.w ||
      current.h !== original.h) {
      return true;
    }
  }

  return false;
}
